import { Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import TrashIcon from "@mui/icons-material/Delete";
import { DataTableProps } from "../types";

export const DataTableSelectedControls = ({
    onDelete,
    onEdit,
}: Pick<DataTableProps, "onDelete" | "onEdit">) => {
    return (
        <>
            {onDelete && (
                <Button
                    color="error"
                    variant="contained"
                    startIcon={<TrashIcon />}
                    onClick={onDelete}
                    sx={{ borderRadius: 2 }}
                >
                    Delete
                </Button>
            )}
            <Button
                variant="contained"
                startIcon={<EditIcon />}
                onClick={onEdit}
                sx={{ borderRadius: 2 }}
            >
                Edit
            </Button>
        </>
    );
};
